export const VOTE_API_ENDPOINT = "https://us-central1-country-leader-board.cloudfunctions.net/votes";